<div class="close">
  <button mat-dialog-close>
    <img
      alt="close"
      width="24"
      height="24"
      src="../../../../assets/images/close.svg"
    />
  </button>
</div>
<div class="title">选择不可用订阅的补偿计划</div>
<div class="content" mat-dialog-content>
  <div class="txt1">确认退款信息:</div>
  <div class="txt1">请核对剩余时长和退款金额。</div>
  <div class="txt2">确认后，将进入环球巴士钱包。</div>

  <div class="detail">
    <div class="item">
      <span class="left">剩余时长</span>
      <span class="right"> {{ data?.info?.remaining_days }}天 </span>
    </div>
    <div class="item">
      <span class="left">预计退款</span
      ><span class="right"> {{ data?.info?.refund_amount }}元</span>
    </div>
  </div>
  <div class="txt1">确认后，当前Adobe车票将取消，操作无法撤回。</div>
</div>
<div class="button">
  <button
    matRipple
    style="background: #c9c8c8"
    [disabled]="loading"
    (click)="back()"
  >
    返回
  </button>
  <button
    matRipple
    style="background: #00ad9d"
    [disabled]="loading"
    (click)="refund()"
  >
    确认退款
  </button>
</div>
